import { Component } from '@angular/core';
import { TabLayoutComponent } from '../../../components/tab-layout/tab-layout.component';
import { TabComponent } from '../../../components/tab/tab.component';
import { APITableComponent } from '../../../components/table/api-table/api-table.component';

@Component({
  selector: 'app-sales-customers-tab',
  imports: [APITableComponent, TabLayoutComponent],
  providers: [
    { provide: TabComponent, useExisting: SalesCustomersTabComponent },
  ],
  templateUrl: './sales-customers-tab.component.html',
})
export class SalesCustomersTabComponent extends TabComponent {
  override name = this.dictionaryService.get('Customers');

  readonly endpoint = '/sale/tables/customer';
  readonly hasChartView = false;
  readonly skipDateRange = false;
  readonly defaultSort: Record<string, 'asc' | 'desc'> = {
    Customer: 'desc',
  };

  override async main(): Promise<void> {}
}
